import { Center, Spinner } from '@chakra-ui/react';

const FullScreenSpinner = () => (
  <Center h="100vh" w="100vw">
    <Spinner color="brand.500" size="xl" thickness="4px" speed="0.65s" emptyColor="dark.700" />
  </Center>
);

export default FullScreenSpinner;
